import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

export const getInsuranceCoverageRequirementName = (
  insuranceCoverage: InsuranceCoverageMonitor | undefined,
  defaultName: string
): string => {
  if (!insuranceCoverage) {
    return defaultName || "Insurance Coverage";
  }

  return defaultName;
};
